import { Form, Formik } from 'formik';
import { observer } from 'mobx-react-lite';
import { useEffect, useState } from 'react';
import { Button, Grid, Icon, Modal } from 'semantic-ui-react';
import { useStore } from '../../app/stores/store';
import * as Yup from 'yup';
import MyTextInput from '../../app/common/form/MyTextInput';
import { SetCurrentUser } from '../../app/models/user';
import ResetPasswordForm from '../Users/ResetPasswordForm';
import '../../app/common/MediaQuery/responsive-profile.css';
import MyNewSelectInput from '../../app/common/form/MyNewSelectInput';
import { userLanguage } from '../../app/common/userLanguageSchema/userLanguage';
import MySelectInput from '../../app/common/form/MySelectInput';

function EditProfile() {
  const {
    userStore,
    mediaAssetStore,
    RolesAndPermissionsStore,
    modalStore,
    departmentStore,
  } = useStore();
  const { rolesByName, rolesRegistry, loadRoles } = RolesAndPermissionsStore;
  const { updateCurrentUser, user } = userStore;
  const [, setOpen] = useState(false);
  const [state, setState] = useState('');
  const [userData, setUserData] = useState<any>([]);
  const [departmentOptions, setDepartmentOptions] = useState<
    { key: string; text: string; value: string }[]
  >([]);
  const phoneRegExp = /^(\+|\d)[0-9]{9,16}$/;
  const initialState = {
    displayName: '',
    image: '',
    username: '',
    fullName: '',
    customerName: '',
    departmentName: user?.departmentName || '',
    addressLine1: '',
    addressLine2: '',
    bio: '',
    email: '',
    country: '',
    state: '',
    city: '',
    postalCode: '',
    phoneNumber: '',
    alternatePhoneNumber: '',
    remarks: '',
    roleId: '',
    workPosition: '',
    superior: '',
    website: '',
    workDepartment: '',
    workApplicationsKnown: '',
    languagesKnown: '',
    isAdmin: true,
    roleName: '',
  };

  useEffect(() => {
    if (departmentStore.departmentsListByCustomerName.length === 0)
      departmentStore.getDepartmentsByCustomer(user?.customerName || '');
    const departmentList = departmentStore.departmentsListByCustomerName.map(
      (x) => ({
        key: x,
        text: x,
        value: x,
      }),
    );
    setDepartmentOptions(departmentList);
    //eslint-disable-next-line
  }, [departmentStore.departmentsListByCustomerName, user?.customerName]);

  // setting the selected vault value to state
  useEffect(() => {
    if (user?.id !== undefined) {
      setUserProfile({
        displayName: user?.displayName,
        image: user?.image,
        username: user?.username,
        fullName: user?.fullName,
        customerName: user?.customerName,
        departmentName: user?.departmentName,
        addressLine1: user?.addressLine1,
        addressLine2: user?.addressLine2,
        // email:user?.email,
        bio: '',
        country: user?.country,
        state: user?.state,
        city: user?.city,
        postalCode: user?.postalCode,
        phoneNumber: user?.phoneNumber,
        alternatePhoneNumber: user?.alternatePhoneNumber,
        remarks: user?.remarks,
        roleId: user?.roleId,
        workPosition: user?.workPosition,
        superior: user?.superior,
        website: user?.website,
        workDepartment: user?.workDepartment,
        workApplicationsKnown: user?.workApplicationsKnown,
        languagesKnown: user?.languagesKnown,
        isAdmin: user?.isAdmin,
        roleName: user?.roleName,
      });
    }
  }, [user]);
  const [userProfile, setUserProfile] = useState<SetCurrentUser>(initialState);
  const { commonStore } = useStore();
  const handleFormSubmit = async (values: SetCurrentUser) => {
    // vault id is null for creating vault
    rolesByName.map((x) =>
      x.id === values.roleId ? (values.roleName = x.roleName) : null,
    );
    const editvalue = {
      ...values,
    };
    await updateCurrentUser(editvalue);
    setTimeout(() => {
      // setting the state to initial value for form reset
      setUserProfile(initialState);
      mediaAssetStore.editProfileModal(false);
    }, 1000);
  };
  const roleOptions = rolesByName.map((x) => ({
    key: x.id,
    text: x.roleName,
    value: x.id,
  }));
  useEffect(() => {
    loadRoles();
    setUserData(rolesByName);
    // eslint-disable-next-line
  }, [userData]);

  useEffect(() => {
    if (user?.roleId !== undefined) {
      rolesByName.forEach((data: any) => {
        if (user?.roleId === data.id) {
          setState(data.roleName);
        }
      });
    } else {
      setState('');
    }
  }, [user, rolesByName]);
  useEffect(() => {
    if (rolesRegistry.size <= 1) loadRoles();
  }, [rolesRegistry.size, loadRoles]);

  return (
    <div>
      <Modal
        onClose={() => setOpen(false)}
        onOpen={() => setOpen(true)}
        open={mediaAssetStore.mediaAsset.editProfile}
      >
        <Modal.Header>
          {' '}
          <Icon
            name="edit"
            //Edit
          />
          {
            (userLanguage[0].ProfileEditModal?.PEMHL01 as any)?.[
              `${commonStore.language.key}`
            ]
          }{' '}
        </Modal.Header>

        <Modal.Content>
          <Formik
            initialValues={userProfile}
            enableReinitialize={true}
            onSubmit={(values) => {
              handleFormSubmit(values);
            }}
            validationSchema={Yup.object({
              displayName: Yup.string()
                .min(2)
                .max(15)
                .matches(
                  /^[aA-zZ\s]+$/,
                  'Only alphabets are allowed for this field ',
                ),
              username: Yup.string()
                .min(2)
                .max(70)
                .matches(/^\S*$/, 'Whitespace is not allowed'),
              // customerName: Yup.string().min(2).max(70),
              departmentName: Yup.string().required(
                'Please select a department',
              ),
              addressLine1: Yup.string()
                .min(2)
                .max(150)
                .required('Please enter address'),
              addressLine2: Yup.string().min(2).max(150),
              phoneNumber: Yup.string()
                .min(9)
                .max(16)
                .matches(phoneRegExp, 'Please enter a valid phone number')
                .required('Please enter phone number')
                .nullable(),
              alternatePhoneNumber: Yup.string()
                .min(9)
                .max(16)
                .matches(phoneRegExp, 'Please enter a valid phone number'),
              roleId: Yup.string().required('Please choose your role'),
            })}
          >
            {({ handleSubmit, isSubmitting, isValid, dirty }) => (
              <Form
                className="ui form error"
                onSubmit={handleSubmit}
                autoComplete="off"
              >
                <Grid container columns={2}>
                  <Grid.Column mobile={16} computer={8} tablet={8}>
                    <MyTextInput
                      name="displayName"
                      label={
                        (userLanguage[0].ProfileEditModal?.PEML01 as any)?.[
                          `${commonStore.language.key}`
                        ]
                      } //"Display Name"
                      placeholder={
                        (userLanguage[0].ProfileEditModal?.PEMTB01 as any)?.[
                          `${commonStore.language.key}`
                        ]
                      } //"Display Name"
                      disabled={true}
                    />{' '}
                  </Grid.Column>
                  <Grid.Column mobile={16} computer={8} tablet={8}>
                    {' '}
                    <MyTextInput
                      disabled
                      name="username"
                      label={
                        (userLanguage[0].ProfileEditModal?.PEML02 as any)?.[
                          `${commonStore.language.key}`
                        ]
                      } //"User Name"
                      placeholder={
                        (userLanguage[0].ProfileEditModal?.PEMTB02 as any)?.[
                          `${commonStore.language.key}`
                        ]
                      } //"User Name"
                    />{' '}
                  </Grid.Column>
                </Grid>
                <Grid container columns={2}>
                  <Grid.Column mobile={16} computer={8} tablet={8}>
                    {' '}
                    <MySelectInput
                      name="departmentName"
                      label={
                        (userLanguage[0].ProfileEditModal?.PEML03 as any)?.[
                          `${commonStore.language.key}`
                        ]
                      } //"Department Name"
                      placeholder={
                        (userLanguage[0].ProfileEditModal?.PEMTB03 as any)?.[
                          `${commonStore.language.key}`
                        ]
                      } //"Department Name"
                      options={departmentOptions}
                      value={user?.departmentName}
                      clearable={false}
                      touched
                      mandatory
                    />
                  </Grid.Column>
                  <Grid.Column mobile={16} computer={8} tablet={8}>
                    {' '}
                    <MyTextInput
                      disabled={user?.isAdmin === true ? false : true}
                      name="customerName"
                      label={
                        (userLanguage[0].ProfileEditModal?.PEML04 as any)?.[
                          `${commonStore.language.key}`
                        ]
                      } //"Customer Name"
                      placeholder={
                        (userLanguage[0].ProfileEditModal?.PEMTB04 as any)?.[
                          `${commonStore.language.key}`
                        ]
                      } //"Customer Name"
                    />{' '}
                  </Grid.Column>
                </Grid>
                <Grid container columns={2}>
                  <Grid.Column mobile={16} computer={8} tablet={8}>
                    {' '}
                    <MyTextInput
                      name="addressLine1"
                      label={
                        (userLanguage[0].ProfileEditModal?.PEML05 as any)?.[
                          `${commonStore.language.key}`
                        ]
                      } //"Address Line 1"
                      placeholder={
                        (userLanguage[0].ProfileEditModal?.PEMTB05 as any)?.[
                          `${commonStore.language.key}`
                        ]
                      } //"Address Line 1"
                      touched
                      mandatory
                    />{' '}
                  </Grid.Column>
                  <Grid.Column mobile={16} computer={8} tablet={8}>
                    {' '}
                    <MyTextInput
                      name="addressLine2"
                      label={
                        (userLanguage[0].ProfileEditModal?.PEML06 as any)?.[
                          `${commonStore.language.key}`
                        ]
                      } //"Address Line 2"
                      placeholder={
                        (userLanguage[0].ProfileEditModal?.PEMTB06 as any)?.[
                          `${commonStore.language.key}`
                        ]
                      } //"Address Line 2"
                    />
                  </Grid.Column>
                </Grid>
                <Grid container columns={2}>
                  <Grid.Column mobile={16} computer={8} tablet={8}>
                    {' '}
                    <MyTextInput
                      name="phoneNumber"
                      label={
                        (userLanguage[0].ProfileEditModal?.PEML07 as any)?.[
                          `${commonStore.language.key}`
                        ]
                      } //"Phone Number"
                      placeholder={
                        (userLanguage[0].ProfileEditModal?.PEMTB07 as any)?.[
                          `${commonStore.language.key}`
                        ]
                      } //"Phone Number"
                      touched
                      mandatory
                    />{' '}
                  </Grid.Column>
                  <Grid.Column mobile={16} computer={8} tablet={8}>
                    {' '}
                    <MyTextInput
                      name="alternatePhoneNumber"
                      label={
                        (userLanguage[0].ProfileEditModal?.PEML08 as any)?.[
                          `${commonStore.language.key}`
                        ]
                      } //"Alternate Phone Number"
                      placeholder={
                        (userLanguage[0].ProfileEditModal?.PEMTB08 as any)?.[
                          `${commonStore.language.key}`
                        ]
                      } //"Alternate Phone Number"
                    />
                  </Grid.Column>
                </Grid>
                <Grid container columns={2}>
                  <Grid.Column mobile={16} computer={8} tablet={8}>
                    {!commonStore.filterModeTwo.includes('SRPB01') && (
                      <MyNewSelectInput
                        name="roleId"
                        options={roleOptions}
                        label={
                          (userLanguage[0].ProfileEditModal?.PEML09 as any)?.[
                            `${commonStore.language.key}`
                          ]
                        } //"Role"
                        placeholder={state}
                        disabled={commonStore.filterModeZero.includes('SRPB01')}
                        touched
                        mandatory
                      />
                    )}
                  </Grid.Column>
                </Grid>
                <Button.Group floated="right" style={{ marginTop: '40px' }}>
                  {commonStore.filterModeTwo?.includes('PEMB02') ? (
                    <></>
                  ) : (
                    <Button
                      onClick={() => mediaAssetStore.editProfileModal(false)}
                      disabled={commonStore.filterModeZero?.includes('PEMB02')}
                      //Cancel
                    >
                      {' '}
                      {
                        (userLanguage[0].ProfileEditModal?.PEMB02 as any)?.[
                          `${commonStore.language.key}`
                        ]
                      }{' '}
                    </Button>
                  )}
                  {commonStore.filterModeTwo?.includes('PEMB02') ||
                  commonStore.filterModeTwo?.includes('PEMB04') ? (
                    <></>
                  ) : (
                    <Button.Or
                      text={
                        (userLanguage[0].ProfileEditModal?.PEMB03 as any)?.[
                          `${commonStore.language.key}`
                        ]
                      }
                      //  style={(commonStore.filterModeTwo?.includes("PEMB04") || commonStore.filterModeTwo?.includes("PEMB02")) ?  {display:'none'} : null }
                    />
                  )}

                  {commonStore.filterModeTwo?.includes('PEMB04') ? (
                    <></>
                  ) : (
                    <Button
                      disabled={
                        !isValid ||
                        !dirty ||
                        commonStore.filterModeZero?.includes('PEMB04')
                      }
                      loading={isSubmitting}
                      type="submit"
                      content="Submit"
                      positive
                      //Submit
                    >
                      {
                        (userLanguage[0].ProfileEditModal?.PEMB04 as any)?.[
                          `${commonStore.language.key}`
                        ]
                      }{' '}
                    </Button>
                  )}
                </Button.Group>
              </Form>
            )}
          </Formik>
        </Modal.Content>
        <Modal.Actions className="smallscreenedit">
          {commonStore.filterModeTwo?.includes('PEMB01') ? (
            <></>
          ) : (
            <Button
              primary
              className="setpwdalign"
              style={{ marginTop: '5px' }}
              onClick={() =>
                modalStore.openModal(
                  <>
                    <ResetPasswordForm />
                  </>,
                )
              }
              disabled={commonStore.filterModeZero?.includes('PEMB01')}
              //Change Password
            >
              {
                (userLanguage[0].ProfileEditModal?.PEMB01 as any)?.[
                  `${commonStore.language.key}`
                ]
              }
            </Button>
          )}
        </Modal.Actions>
      </Modal>
    </div>
  );
}

export default observer(EditProfile);
